export default {
    "FinancialGuide": "Financial guidance for your home",
    "GetSmarterSubText":"Get smarter about your biggest asset. Understand your home’s value, uncover hidden savings, and build long-term wealth using our complete financial toolkit for homeownership.",
    "Address":"Enter your address",
    "GetStarted":"Get Started",
    "HomeWorth":"KNOW WHAT YOUR HOME IS WORTH",
    "HomeMarketValue":"Monitor Your Home's Market Value",
    "Valuation":"Receive a free, data-driven valuation of your home based on up-to-date market insights and comparable home sales.",
    "MortgageTracking":"MORTGAGE AND EQUITY TRACKING",
    "MortgageBalance":"Track Equity and Mortgage Balances",
    "TrackHome":"Track your home equity, optimize your mortgage, and learn how to build long term wealth.",
    "HomeOwnerTools":"TOOLS FOR SUCCESSFUL HOMEOWNERSHIP",
    "PersonalizedAlerts":"Get Personalized Maintenance Alerts",
    "PersonalizedMaintanance": "Receive personalized maintenance checklists and get connected with top-rated home professionals.",
    "PlanFuture": "PLAN FOR THE FUTURE",
    "ExpertGuidance": "Unlock Expert Guidance for Every Step",
    "PersonalizedSuggestions": "Personalized suggestions to help you save on property taxes, insurance, and mortgages.",
    "LifeInvestment": "Manage Life’s Biggest Investment",
    "YourHome": "With personalized guidance and intuitive tools, you can make informed decisions around life’s biggest asset — your home.",
    "MeetAgent": "Meet with a real estate agent today"
}